import { FormType } from "@simplyk/common";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";

export interface SalesOpenSchedule {
  salesOpenDate: Date | null;
  isSalesScheduled: boolean;
}

export const useSalesOpenSchedule = (): SalesOpenSchedule => {
  const { selectedOccurrenceWithRates, formObject: ticketing } = useFormV2Context(FormType.Ticketing);

  const raw = selectedOccurrenceWithRates?.occurrence?.openDate ?? ticketing?.salesOpenDate ?? null;
  const salesOpenDate = raw ? new Date(raw) : null;
  const isSalesScheduled = Boolean(salesOpenDate && salesOpenDate > new Date());

  return { salesOpenDate, isSalesScheduled };
};
